import actionTypes from '../../constants/actions/importarContactosExcel/importarContactosExcel'

export function submitImportarContactosExcel (value) {
  return {
    type: actionTypes.SUBMIT_IMPORTAR_CONTACTOS_EXCEL,
    value
  }
}

export function submitImportarContactosExcelSuccess (listImportarContactosExcel) {
  return {
    type: actionTypes.SUBMIT_IMPORTAR_CONTACTOS_EXCEL_SUCCESS,
    listImportarContactosExcel
  }
}

export function abrirModalImportarContactosExcel () {
  return {
    type: actionTypes.ABRIR_MODAL_IMPORTAR_CONTACTOS_EXCEL
  }
}

export function cerrarModalImportarContactosExcel () {
  return {
    type: actionTypes.CERRAR_MODAL_IMPORTAR_CONTACTOS_EXCEL
  }
}

export function subirArchivosImportarContactosExcel (archivoExcel) {
  return {
    type: actionTypes.SUBIR_ARCHIVOS_IMPORTAR_CONTACTOS_EXCEL,
    archivoExcel
  }
}

export function descargarPlantillaExcelContactosExcel () {
  return {
    type: actionTypes.DESCARGAR_PLANTILLA_EXCEL_CONTACTOS_EXCEL
  }
}

export default {
  submitImportarContactosExcel,
  abrirModalImportarContactosExcel,
  cerrarModalImportarContactosExcel,
  subirArchivosImportarContactosExcel,
  submitImportarContactosExcelSuccess,
  descargarPlantillaExcelContactosExcel
}